import Fab from '@material-ui/core/Fab';
import { history } from 'umi';
import AddIcon from '@material-ui/icons/Add';
import ActionButtonGroupStyled from './ActionButtonGroupStyled';

const ActionBtnGroup = () => {
  //跳转到新增礼品
  const handleClickAdd = () => {
    history.push({
      pathname: '/integral/gift_management/management_gift_form_add',
      query: {
        opt: 'add',
        sourceOid: 'btn_point_mall_gift_management_list_create',
      },
    });
  };
  return (
    <ActionButtonGroupStyled>
      <div className="export-wrapper">
        <Fab
          data-log={JSON.stringify({
            oid: 'btn_point_mall_gift_management_list_create',
            events: ['_ev', 'ec'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          sx={{ marginRight: '16px' }}
          onClick={handleClickAdd}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建礼品
        </Fab>
      </div>
    </ActionButtonGroupStyled>
  );
};
export default ActionBtnGroup;
